
  import imgLoginServe from '@/assets/image/artificial-services/login-serve.png'
  import sampleCollection from '@/assets/image/artificial-services/sample-collection.png'
  import dataRecovery from '@/assets/image/artificial-services/data-recovery.png'
  import advertisingFree from '@/assets/image/artificial-services/advertising-free.png'
  import openPlatform from '@/assets/image/artificial-services/open-platform.png'
  import researchServices from '@/assets/image/artificial-services/research-services.png'
  import qrWx from '@/assets/image/artificial-services/qr-wx.png'

  import { distinguishUserAgentUtils } from '~/utils/tools'

  export default {
    name: 'ArtificialServices',
    components: {},
    layout: 'template-page',
    header: {
      title: '人工服务-问卷网',
      link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/service/' }],
    },
    data() {
      return {
        serveCount: 0,
        openCount: 0,
        cardList: [
          {
            icon: imgLoginServe,
            title: '问卷录入服务',
            question: '问卷保存在Word里，录入好麻烦？',
            answer: '我们会安排专人协助您将问卷录入问卷网，方便您线上分发。',
            payList: [
              {
                label: '专人问卷录入',
                value: '低至500元',
              },
              {
                label: '定制化问卷录入',
                value: '人工报价',
              },
            ],
          },
          {
            icon: sampleCollection,
            title: '样本收集服务',
            question: '找样本，有困难？',
            answer: '我们有覆盖全国的840万用户，一天收集2000余份答卷不是梦。',
            payList: [
              {
                label: '样本服务',
                value: '每个样本低至0.9元',
              },
              {
                label: '短信分发',
                value: '每条短信0.1元',
              },
              {
                label: '电邮分发',
                value: '每封邮件0.035元',
              },
            ],
          },
          {
            icon: dataRecovery,
            title: '数据恢复',
            question: '数据误删无法修复？',
            answer: '1年以内误删的数据都有机会修复，我们有专业的工程师为您评估。',
            payList: [
              {
                label: '数据恢复',
                value: '每次399元起',
              },
            ],
          },
          {
            icon: advertisingFree,
            title: '免广告',
            question: '不想让答题者看到广告？',
            answer: '订购问卷网高级版，彻底免除广告干扰，提升企业形象！',
            payList: [
              {
                label: '高级版',
                value: '每年2499起',
              },
              {
                label: '企业版',
                value: '每年5499起',
              },
            ],
          },
        ],
        cardBoardList: [
          {
            icon: openPlatform,
            title: '开放平台',
            question: '能为开发者提供怎样的服务？',
            answer: '开发者可以通过API对接问卷网账号、管理项目、查询数据与接收推送',
            qrCode: qrWx,
          },
          {
            icon: researchServices,
            title: '专业调研服务',
            question: '没做过调研，不知从何做起？',
            answer: '专业的调研团队帮你做调研设计、样本收集、数据分析、报告撰写，一站式服务',
            qrCode: qrWx,
          },
        ],
        isMobile: false,
        serveTouch: '',
        openTouch: '',
      }
    },
    head: {
      title: '人工服务-问卷网',
      link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/service/' }],
    },
    computed: {
      serveContentStyle() {
        if (!this.isMobile) return {}
        let translate = this.serveCount * 285
        if (this.serveCount == this.cardList.length - 1) {
          translate -= document.body.clientWidth - 309
        }
        return {
          transform: `translate(-${translate}px, 0px)`,
        }
      },
      openContentStyle() {
        if (!this.isMobile) return {}
        let translate = this.openCount * 285
        if (this.openCount == this.cardBoardList.length - 1) {
          translate -= document.body.clientWidth - 309
        }
        return {
          transform: `translate(-${translate}px, 0px)`,
        }
      },
    },
    mounted() {
      this.isMobile = distinguishUserAgentUtils().isMobile
      console.log(this.isMobile)
    },
    methods: {
      // 模板滑动事件
      serveTouchStart(e) {
        /* eslint-disable-next-line */
        this.serveTouch = e.changedTouches[0]
      },
      // 模板滑动事件
      serveTouchEnd(e) {
        const touchEnd = e.changedTouches[0]
        if (touchEnd.clientX > this.serveTouch.clientX && touchEnd.clientX - this.serveTouch.clientX > 40) {
          if (this.serveCount == 0) return
          this.serveCount--
        }
        if (this.serveTouch.clientX > touchEnd.clientX && this.serveTouch.clientX - touchEnd.clientX > 40) {
          if (this.serveCount == this.cardList.length - 1) return
          this.serveCount++
        }
      },
      // 模板滑动事件
      openTouchStart(e) {
        /* eslint-disable-next-line */
        this.openTouch = e.changedTouches[0]
      },
      // 模板滑动事件
      openTouchEnd(e) {
        const touchEnd = e.changedTouches[0]
        if (touchEnd.clientX > this.openTouch.clientX && touchEnd.clientX - this.openTouch.clientX > 40) {
          if (this.openCount == 0) return
          this.openCount--
        }
        if (this.openTouch.clientX > touchEnd.clientX && this.openTouch.clientX - touchEnd.clientX > 40) {
          if (this.openCount == this.cardBoardList.length - 1) return
          this.openCount++
        }
      },
      gotoSurvey() {
        window.location.href = '/s/RBnAzeb'
      },
    },
  }
